/*
 * @Author: mayanxia
 * @Date: 2023-03-08 09:37:17
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-06-16 11:25:11
 */


<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备编号')">
              <j-input :placeholder="$t('输入设备编号模糊查询')" v-model="queryParam.deviceId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备名称')">
              <j-input :placeholder="$t('输入设备名称模糊查询')" v-model="queryParam.deviceName"></j-input>
            </a-form-item>
          </a-col>
            <a-col :span="8">
                  <a-form-model-item :label="$t('上报时间')">
                    <a-range-picker
                      v-model="date"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      format="YYYY-MM-DD"
                      @change="onDateRangeChange"
                    />
                  </a-form-model-item>
                </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls($t('井电双控-实时数据'))">{{ $t('导出') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" class="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>

    <well-elec-controll-last-record-modal ref="modalForm" @ok="modalFormOk"></well-elec-controll-last-record-modal>
  </a-card>
</template>

<script>

  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WellElecControllLastRecordModal from './modules/WellElecControllLastRecordModal'
  import JInput from '@/components/jeecg/JInput'
  import { getAction } from '@/api/manage'

  export default {
    name: 'WellElecControllLastRecord',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      WellElecControllLastRecordModal,
      JInput
    },
    data () {
      return {
        description: '井电双控实时数据管理页面',
        url: {
          list: "/jeecg-charge/part/partWellElecControllLastRecord/list",
          exportXlsUrl: "/jeecg-charge/part/partWellElecControllLastRecord/exportXls",
        },
        dictOptions:{},
        /* 排序参数 */
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        dateType: 2
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName'
          },{
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'terminalNo'
          },
          {
            title: this.$t('水利编号'),
            align:"center",
            dataIndex: 'waterConservancyNo'
          },
          {
            title: this.$t('状态'),
            align:"center",
            dataIndex: 'meterSwitchStatus',
            customRender: (t,r,index) => {
              if(t == 0) {
                return this.$t("关泵");
              }else{
                return this.$t("在线抽水中");
              }
            }
          },
          {
            title: this.$t('报警状态'),
            align:"center",
            dataIndex: 'meterWarnStatus',
            customRender: (t,r,index) => {
              if(t == 1) {
                return this.$t("综合保护器报警");
              }else if(t == 2){
                return this.$t("有脉冲干扰");
              }else if(t == 3){
                return this.$t("断线报警");
              }
              return this.$t("正常");
            }
          },
          {
            title: this.$t('最后通讯时间'),
            align:"center",
            dataIndex: 'sysTime'
          },
          {
            title: this.$t('箱门状态'),
            align:"center",
            dataIndex: 'meterDoorStatus',
            customRender: (t,r,index) => {
              if(t == 0) {
                return this.$t("箱门关闭");
              }else if(t == 1){
                return this.$t("箱门开启");
              }
              return "--";
            }
          },
          {
            title: this.$t('剩余水量(m³)'),
            align:"center",
            dataIndex: 'meterRemainNum'
          },
          {
            title: this.$t('总用水量(m³)'),
            align:"center",
            dataIndex: 'meterTotalUse'
          },
          {
            title: this.$t('取水证号及电子证号'),
            align:"center",
            dataIndex: 'waterCollectionNo'
          },
          {
            title: this.$t('计量方式(m³/h)'),
            align:"center",
            dataIndex: 'measureWay'
          },
          {
            title: this.$t('井地址'),
            align:"center",
            dataIndex: 'deviceLocation'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            let dataSource = res.result.records;
            if(dataSource.length>0) {
              for(let i = 0;i<dataSource.length;i++) {
                let resRemark = dataSource[i].resRemark1;
                if(resRemark!="") {
                  console.log(resRemark)
                  let resRemarkObj = JSON.parse(resRemark);
                  // 终端号
                  dataSource[i].terminalNo = resRemarkObj.terminalNo;
                  // 水利编号
                  dataSource[i].waterConservancyNo = resRemarkObj.waterConservancyNo;
                  // 取水证号
                  dataSource[i].waterCollectionNo = resRemarkObj.waterCollectionNo;
                  // 计量方式
                  dataSource[i].measureWay = resRemarkObj.measureWay;
                }
              }
            }
            this.dataSource = dataSource;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
    }
  }
</script>
